import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/iamprogrez.webp';
import screenshot_target from '../../../images/letterfunnel/lindafrietman.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Linda Frietman"
      firstname="Linda"
      companyname="iamprogrez"
      competition="Equalture en SkillLab"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/lindafrietman.js